import { defineComponent as o, createBlock as t, openBlock as r, unref as p, mergeProps as m, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconDesign",
  __name: "IconDesign",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const l = n;
    return (s, e) => (r(), t(p(v), m(l, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", { d: "M4.75 5.5A.75.75 0 0 1 5.5 4.75H7a.75.75 0 0 0 0-1.5H5.5A2.25 2.25 0 0 0 3.25 5.5V7a.75.75 0 0 0 1.5 0V5.5M5.5 19.25a.75.75 0 0 1-.75-.75V17a.75.75 0 0 0-1.5 0v1.5a2.25 2.25 0 0 0 2.25 2.25H7a.75.75 0 0 0 0-1.5H5.5m13 0a.75.75 0 0 0 .75-.75V17a.75.75 0 0 1 1.5 0v1.5a2.25 2.25 0 0 1-2.25 2.25H17a.75.75 0 0 1 0-1.5h1.5M19.25 5.5V7a.75.75 0 0 0 1.5 0V5.5a2.25 2.25 0 0 0-2.25-2.25H17a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 1 .75.75" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M11.357 6.011a1.25 1.25 0 0 1 1.286 0l4.5 2.7a1.25 1.25 0 0 1 .607 1.072v4.434a1.25 1.25 0 0 1-.607 1.072l-4.5 2.7a1.25 1.25 0 0 1-1.286 0l-4.5-2.7a1.25 1.25 0 0 1-.607-1.072V9.783a1.25 1.25 0 0 1 .607-1.072l4.5-2.7M8.457 9.5 12 11.625 15.542 9.5 12 7.375 8.458 9.5m7.793 1.325-3.5 2.1v3.25l3.5-2.1v-3.25m-5 5.35v-3.25l-3.5-2.1v3.25l3.5 2.1",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
